import{createContext as e}from"react";import{noopFn as r}from"@danfoss-source/core";const o=e({searchApiKeyMap:{},setSearchApiKey:r,getSearchApiKey:()=>""});export{o as AlgoliaApiKeyContext};
